// New-account contact guard (owner, 2026-09-24): accounts younger than 7 days can't post links,
// messenger handles, emails or phone numbers — enforced in Postgres (reject_new_account_contact
// trigger, migration 20260924090000), whose Serbian error text starts with this mark.
export const NEW_ACCOUNT_CONTACT_MARK = 'Novi nalozi (prvih 7 dana)';

export function isNewAccountContactBlock(message: string | null | undefined): boolean {
  return !!message && message.includes(NEW_ACCOUNT_CONTACT_MARK);
}

export type ContactGuardSurface = 'live_chat' | 'dm' | 'trade_comment' | 'forum_thread' | 'forum_comment';
